import BaseExecutor from 'services/sports/default/base-executor';
import {MinAdjustedPlayersValidatorBuilder} from 'services/sports/draftkings/validator/min-adjusted-players-validator-builder';
import Action from 'actions';
import BaseValidator from 'services/validations/base-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';
import {ControlledNameStackingValidatorBuilder} from 'services/sports/nhl/validator/controlled-name-stacking-validator-builder';
import {NhlTeamStackingValidatorBuilder} from 'services/sports/nhl/validator/nhl-team-stacking-validator-builder';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            userPointsType,
            stacks: {nhlName: controlledNameStacking},
            nhlTeamStacking,
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (nhlTeamStacking.isEnabled()) {
            const nhlTeamStackingValidatorBuilder = new NhlTeamStackingValidatorBuilder().getInterface();
            validator.addSubValidators([nhlTeamStackingValidatorBuilder]);
        }

        if (controlledNameStacking.isEnabled()) {
            const controlledNameStackingValidatorBuilder = new ControlledNameStackingValidatorBuilder().getInterface();
            validator.addSubValidators([controlledNameStackingValidatorBuilder]);
        }

        if (!this.isAnyStackingUsed()) {
            const minAdjustedPlayersValidator = new MinAdjustedPlayersValidatorBuilder({
                propNameOfDefaultUserPointsValue: userPointsType.getUserPointsType(),
            }).getInterface();
            validator.addSubValidators([minAdjustedPlayersValidator]);
        }

        return validator;
    }

    isAnyStackingUsed() {
        const {
            nhlTeamStacking,
            nhlLegacyTeamStacking,
            playerCombinationStacking,
            projectionBoostRule,
            stacks: {nhlName, nonControlled},
        } = Action.getState();

        return (
          (nonControlled.isEnabled() && nonControlled.hasItems()) ||
          nhlTeamStacking.isEnabled() ||
          nhlLegacyTeamStacking.isEnabled() ||
          (playerCombinationStacking.isEnabled() && playerCombinationStacking.hasItems()) ||
          nhlName.isEnabled() ||
          (projectionBoostRule.isEnabled() && projectionBoostRule.hasItems())
        );
    }
}
